export const STATUS_ID = {
	ACTIVE: 1,
};
